import axios from 'axios'
import constants from '../constants'

const getSDSItemLink = async (customerNumber: string, itemNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sds/get-link/${itemNumber}`)
  const link: string = response?.data?.link

  return link;
};

export { getSDSItemLink };
